import { render } from "./Info.vue?vue&type=template&id=767ef762&scoped=true"
const script = {}

import "./Info.vue?vue&type=style&index=0&id=767ef762&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767ef762"]])

export default __exports__